import { useState } from 'react';
import { Link } from 'react-router-dom';

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="fixed w-full z-50 top-0 bg-darker/90 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20">

          {/* Logo */}
          <div className="flex items-center gap-2">
            <img
              alt="Golden 777 Logo"
              className="h-9 w-9 md:h-12 md:w-auto rounded-lg object-cover"
              src="/777icon.jpg"
            />
            <span className="font-serif text-lg md:text-2xl font-black tracking-tighter bg-clip-text text-transparent bg-gradient-to-r from-accent via-white to-accent uppercase">
              Golden 777
            </span>
          </div>

          {/* Desktop links */}
          <div className="hidden md:flex items-center space-x-8">
            <Link className="nav-link text-sm font-semibold uppercase tracking-widest text-slate-300 hover:text-primary" to="/privacy-policy">Privacy Policy</Link>
            <Link className="nav-link text-sm font-semibold uppercase tracking-widest text-slate-300 hover:text-primary" to="/terms-and-conditions">Terms</Link>
          </div>

          {/* Mobile hamburger */}
          <div className="flex md:hidden">
            <button
              aria-label="Open menu"
              className="p-1 text-white"
              onClick={() => setIsOpen((v) => !v)}
              type="button"
            >
              <span className="material-icons text-3xl">menu</span>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden flex-col bg-darker border-t border-slate-800 px-4 py-4 space-y-3 ${isOpen ? 'open mobile-menu' : 'mobile-menu'}`}>
        <Link className="block text-sm font-semibold uppercase tracking-widest text-slate-300 hover:text-primary py-2 border-b border-slate-800" to="/privacy-policy" onClick={closeMenu}>Privacy Policy</Link>
        <Link className="block text-sm font-semibold uppercase tracking-widest text-slate-300 hover:text-primary py-2 border-b border-slate-800" to="/terms-and-conditions" onClick={closeMenu}>Terms &amp; Conditions</Link>
      </div>
    </nav>
  );
}
